import React from "react";
import { connect } from "react-redux";

import Loader from "components/atoms/loader";
import Button from "components/atoms/button";
import FormActions from "components/molecules/formActions";
import FormFieldset from "components/molecules/formFieldset";

class LinkingPosCheckout extends React.Component {
  render() {
    const { transactionNumber, amount, vehicle, company } = this.props;

    return (
      <div>
        {transactionNumber == null && <Loader />}

        {transactionNumber !== null && (
          <div>
            <FormFieldset>
              <h4>Todo listo.</h4>
              <p>
                Procederás al pago de la seña de <strong>$50.000</strong> para
                confirmar la reserva de tu próximo{" "}
                <strong>{vehicle.brand}</strong> <strong>{vehicle.name}</strong>
                .
              </p>
            </FormFieldset>
            <FormFieldset>
              {company === "chevrolet" && (
                <iframe
                  title="Pago con LinkingPOS"
                  src={`https://linkingpos.com/external_payments/new?access_token=qfLbMiCFSJvjiDeDcqCoTxtx&import=${amount}&client_ref=${transactionNumber}`}
                  style={{
                    width: "100%",
                    height: "820px",
                    overflowY: "hidden",
                  }}
                  scrolling="no"
                  frameBorder="0"
                ></iframe>
              )}
              {company === "volskwagen" && (
                <iframe
                  title="Pago con LinkingPOS"
                  src={`https://linkingpos.com/external_payments/new?access_token=gcu1tr29S7Tf7DPkiJR3KoRy&import=${amount}&client_ref=${transactionNumber}`}
                  style={{
                    width: "100%",
                    height: "820px",
                    overflowY: "hidden",
                  }}
                  scrolling="no"
                  frameBorder="0"
                ></iframe>
              )}
              {company === "nissan" && (
                <iframe
                  title="Pago con LinkingPOS"
                  src={`https://linkingpos.com/external_payments/new?access_token=ZVwLKwS7hugny35TxvSewV9o&import=${amount}&client_ref=${transactionNumber}`}
                  style={{
                    width: "100%",
                    height: "820px",
                    overflowY: "hidden",
                  }}
                  scrolling="no"
                  frameBorder="0"
                ></iframe>
              )}
            </FormFieldset>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactionNumber: state.purchase.transactionNumber,
    vehicle: state.stock.item,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkingPosCheckout);
